module.exports = __webpack_public_path__ + "96243c33efba8320499459f46c1c0e75.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/raw-key-art-768.jpg
// module id = 521
// module chunks = 0